/* CASA · SHOPIFY BRIDGE
   Loaded in <head>, before any of the site's own scripts. The site's code is moved
   into this theme unchanged; it still asks for /api/... the way it did on Vercel.
   This file answers those requests from Shopify instead, in the same shapes the
   Vercel functions returned, so the page behaves exactly as before.

   Rules:
   - Never forward a request to the old Vercel site. Test traffic from this theme
     must not write into the live database.
   - Anything not moved yet answers 503 with a plain message, so the page shows its
     normal failure state instead of breaking.
   - Checkout is untouched: the page still creates its cart through Shopify's
     Storefront API directly (casaShopifyCommerce), exactly as on Vercel. */
(function () {
  'use strict';

  // Terms boxes on short screens (phones held landscape, found 29 Sep 2026): the card is
  // capped at 88vh and only the document scrolls, so the tick box, email, name and
  // button were cut off with no way to reach them. Below 600px of height the card itself
  // is the ONE scrolling area, capped at the visible height, and the document flows
  // inside it (no second scroller). A first attempt that scrolled the overlay and kept a
  // small document window failed on a real iPhone: one line of text, no scrolling.
  // !important because the page's own rules (casa-05.js) load after this file. dvh =
  // the visible height on iPhone Safari and Chrome; the vh line is the fallback.
  try {
    var shortCss = document.createElement('style');
    shortCss.textContent = '@media (max-height:600px){' +
      '.casa-legal-modal{padding:8px!important;align-items:center!important;}' +
      '.casa-legal-card{display:block!important;max-height:calc(100vh - 16px)!important;' +
      'max-height:calc(100dvh - 16px)!important;overflow-y:auto!important;' +
      '-webkit-overflow-scrolling:touch;overscroll-behavior:contain;}' +
      '.casa-legal-body{overflow:visible!important;max-height:none!important;flex:none!important;}' +
      '.casa-legal-head{padding-top:14px!important;padding-bottom:10px!important;}' +
      '.casa-legal-foot{padding-top:12px!important;padding-bottom:14px!important;}}';
    document.head.appendChild(shortCss);
  } catch (e) {}

  // "Your Privacy Choices" in the footer (29 Sep 2026, Erich's go). The Privacy Policy in
  // force (v2026-08-29, section 6) tells shoppers to opt out "by using the 'Your Privacy
  // Choices' link available on our Services"; the site never had that link. It opens
  // Shopify's opt-out page (templates/page.liquid). The footer's legal links are built
  // by the page once the documents load (casa-05.js injectHub), so wait for them.
  function addPrivacyChoices() {
    var pp = document.querySelector('.casa-legal-hub a[data-slug="privacy-policy"]');
    if (!pp || document.querySelector('.casa-legal-hub a.casa-privacy-choices')) return !!pp;
    var a = document.createElement('a');
    a.className = 'casa-privacy-choices';
    a.href = '/pages/data-sharing-opt-out';
    a.textContent = 'Your Privacy Choices';
    pp.parentNode.insertBefore(a, pp.nextSibling);
    return true;
  }
  try {
    var pcObs = new MutationObserver(function () { if (addPrivacyChoices()) pcObs.disconnect(); });
    pcObs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { pcObs.disconnect(); }, 60000);
  } catch (e) {}

  var SF_DOMAIN = 'casa-consignment.myshopify.com';
  // Public Storefront token, the same one the live page ships (safe client-side).
  var SF_TOKEN = '735ee8b36c9afb58852dd5088fe05253';
  var SF_API = 'https://' + SF_DOMAIN + '/api/2024-10/graphql.json';
  var MF_KEYS = ['colour', 'hardware', 'size', 'condition', 'collection_year', 'includes', 'material', 'category'];

  var realFetch = window.fetch.bind(window);

  function json(status, body) {
    return Promise.resolve(new Response(JSON.stringify(body), {
      status: status, headers: { 'Content-Type': 'application/json' }
    }));
  }

  function sf(query, variables) {
    return realFetch(SF_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  // ---- catalogue ------------------------------------------------------------
  var PRODUCTS_Q = 'query CasaCatalog($cursor: String) {' +
    ' products(first: 250, after: $cursor) { pageInfo { hasNextPage endCursor } nodes {' +
    ' id handle title vendor createdAt availableForSale onlineStoreUrl' +
    ' images(first: 30) { nodes { url } }' +
    ' variants(first: 1) { nodes { id sku availableForSale price { amount } } }' +
    ' metafields(identifiers: [' + MF_KEYS.map(function (k) {
      return '{namespace: "custom", key: "' + k + '"}';
    }).join(',') + ']) { key value } } } }';

  // Same rule as stripVendor() in api/webhooks/shopify.mjs: the site prints the
  // brand separately, so a title that starts with the vendor drops it once.
  function stripVendor(title, vendor) {
    var v = String(vendor || '').trim();
    if (!v) return title;
    return title.toLowerCase().indexOf(v.toLowerCase()) === 0
      ? (title.slice(v.length).replace(/^[\s·\-—]+/, '').trim() || title)
      : title;
  }
  function numericId(gid) { return String(gid || '').split('/').pop(); }
  function money(amount) { var n = Number(amount); return isNaN(n) ? null : String(n); }

  var catalog = null; // { products: [...], bySku: {} }
  function loadCatalog() {
    if (catalog) return catalog;
    var all = [];
    function page(cursor) {
      return sf(PRODUCTS_Q, { cursor: cursor || null }).then(function (d) {
        if (!d || !d.data) throw new Error('storefront: ' + JSON.stringify(d && d.errors || d).slice(0, 200));
        var p = d.data.products;
        all = all.concat(p.nodes);
        return p.pageInfo.hasNextPage ? page(p.pageInfo.endCursor) : all;
      });
    }
    catalog = page().then(function (nodes) {
      var bySku = {}, products = [];
      nodes.forEach(function (n) {
        var v = (n.variants.nodes || [])[0] || {};
        var sku = String(v.sku || '').trim().toUpperCase();
        // Blank SKU = the three membership products. Same rule as the Vercel sync.
        if (!sku) return;
        var mf = {};
        (n.metafields || []).forEach(function (m) { if (m && m.key) mf[m.key] = m.value; });
        var url = n.onlineStoreUrl ? new URL(n.onlineStoreUrl).pathname : null;
        bySku[sku] = { url: url, handle: n.handle, category: mf.category || null, material: mf.material || null,
          productId: numericId(n.id), variantId: numericId(v.id), brand: String(n.vendor || '').trim(),
          name: stripVendor(String(n.title || '').trim(), n.vendor), price: money(v.price && v.price.amount),
          image: (n.images.nodes[0] || {}).url || null, available: !!(n.availableForSale && v.availableForSale) };
        // /api/products only ever listed pieces that are for sale; sold stays off.
        if (!n.availableForSale || !v.availableForSale) return;
        var price = money(v.price && v.price.amount);
        products.push({
          sku: sku,
          brand: String(n.vendor || '').trim(),
          name: stripVendor(String(n.title || '').trim(), n.vendor),
          color: mf.colour || null,
          condition: mf.condition || null,
          size: mf.size || null,
          year: mf.collection_year || null,
          hardware: mf.hardware || null,
          price: price,
          gallery: (n.images.nodes || []).map(function (i) { return i.url; }),
          status: 'active',
          consignor_id: null,
          auth_status: 'pending',
          legit_case_id: null,
          created_at: n.createdAt,
          shopify_variant_id: numericId(v.id),
          shopify_price: price,
          shopify_saleable: true,
          // Sheet-only rule: text Casa did not write is never carried over.
          editorial: '',
          shopify_product_id: numericId(n.id),
          includes: mf.includes || null
        });
      });
      // A category set in Shopify wins over the page's built-in map, so Casa can
      // recategorise a piece from the admin.
      try {
        window.CASA_CATEGORY = window.CASA_CATEGORY || {};
        Object.keys(bySku).forEach(function (s) { if (bySku[s].category) window.CASA_CATEGORY[s] = bySku[s].category; });
      } catch (e) {}
      // /api/products answers ORDER BY created_at DESC, and every piece carries the
      // same placeholder date, so this order IS the "Newest" sort. Shopify returns
      // oldest first.
      products.sort(function (a, b) { return String(b.created_at || '').localeCompare(String(a.created_at || '')); });
      window.__casaShopifyBySku = bySku;
      return { products: products, bySku: bySku };
    });
    catalog.catch(function () { catalog = null; });
    return catalog;
  }
  loadCatalog();

  // Product page address for a SKU, once the catalogue is known. casaBagPath() in
  // the page asks this first and falls back to its own /bag/ path.
  window.casaShopifyUrl = function (sku) {
    var m = window.__casaShopifyBySku && window.__casaShopifyBySku[String(sku || '').toUpperCase()];
    return (m && m.url) || null;
  };

  // ---- legal documents and signatures ---------------------------------------
  // Same contract as api/legal.js on Vercel. Documents come from the theme asset
  // casa-legal-documents.json (every published version, exact body, stored hash,
  // built from the Neon export). Signatures are kept in this browser and attached
  // to the Shopify cart as attributes at cartCreate, so they are saved on the order
  // (Shopify records the buyer's IP on the order itself).
  var REQUIRED = {
    account: ['terms-of-service', 'privacy-policy'],
    purchase: ['buyer-terms-of-purchase'],
    consignor: ['consignor-terms'],
    membership: ['membership-terms']
  };
  var GATE = {};
  Object.keys(REQUIRED).forEach(function (ctx) { REQUIRED[ctx].forEach(function (s) { GATE[s] = ctx; }); });
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var SIG_KEY = 'casa_legal_signatures';

  var legalDocs = null;
  function loadLegal() {
    if (!legalDocs) {
      legalDocs = realFetch(window.CASA_ASSET('casa-legal-documents.json'))
        .then(function (r) { if (!r.ok) throw new Error('legal documents ' + r.status); return r.json(); })
        .then(function (all) {
          var latest = {};
          all.forEach(function (d) {
            if (!latest[d.slug] || d.published_at > latest[d.slug].published_at) latest[d.slug] = d;
          });
          return { all: all, latest: latest };
        });
      legalDocs.catch(function () { legalDocs = null; });
    }
    return legalDocs;
  }
  function readSigs() { try { var a = JSON.parse(localStorage.getItem(SIG_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function writeSigs(a) { try { localStorage.setItem(SIG_KEY, JSON.stringify(a.slice(-50))); } catch (e) {} }

  function legalRoute(u, init) {
    var method = String((init && init.method) || 'GET').toUpperCase();
    return loadLegal().then(function (L) {
      if (method === 'GET') {
        var slug = u.searchParams.get('slug'), ctx = u.searchParams.get('required');
        if (slug) {
          var d = L.latest[slug];
          if (!d) return json(404, { error: 'unknown document: ' + slug });
          return json(200, { document: { slug: d.slug, version: d.version, title: d.title,
            effective_date: d.effective_date, content_hash: d.content_hash, body: d.body } });
        }
        if (ctx) {
          var who = String(u.searchParams.get('email') || '').trim().toLowerCase();
          var sigs = who ? readSigs().filter(function (s) { return s.email === who; }) : [];
          var docs = (REQUIRED[ctx] || []).map(function (s) {
            var d = L.latest[s];
            // Past signatures imported onto the Shopify customer as tags
            // ("casa-signed:<slug>@<version>") count too, for the signed-in customer.
            var cust = window.CASA_CUSTOMER;
            var tagged = !!(d && cust && String(cust.email || '').toLowerCase() === who &&
              (cust.tags || []).indexOf('casa-signed:' + s + '@' + d.version) !== -1);
            var accepted = tagged || !!(d && sigs.some(function (x) { return x.slug === s && x.version === d.version; }));
            return { slug: s, version: d && d.version, title: d && d.title, accepted: accepted };
          }).filter(function (d) { return d.version; });
          return json(200, { context: ctx, documents: docs,
            allAccepted: docs.length > 0 && docs.every(function (d) { return d.accepted; }) });
        }
        return json(200, {
          documents: Object.keys(L.latest).sort().map(function (s) {
            var d = L.latest[s];
            return { slug: d.slug, version: d.version, title: d.title, effective_date: d.effective_date,
              content_hash: d.content_hash, published_at: d.published_at, gate: GATE[s] || d.gate || null };
          }),
          required: REQUIRED
        });
      }
      if (method === 'POST') {
        var b = {}; try { b = JSON.parse((init && init.body) || '{}'); } catch (e) {}
        var slug2 = String(b.slug || '').trim(), context = String(b.context || '').trim();
        var name = String(b.signed_name || '').trim().slice(0, 160);
        var email = String(b.email || '').trim().toLowerCase().slice(0, 254);
        if (!slug2) return json(400, { error: 'slug required' });
        if (!REQUIRED[context]) return json(400, { error: 'context must be one of: ' + Object.keys(REQUIRED).join(', ') });
        if (name.length < 2) return json(400, { error: 'Please type your full legal name to sign.' });
        if (!email || !EMAIL_RE.test(email)) return json(400, { error: 'A valid email is required to record the signature.' });
        var doc = L.latest[slug2];
        if (!doc) return json(404, { error: 'unknown document: ' + slug2 });
        var rec = { slug: doc.slug, version: doc.version, content_hash: doc.content_hash, title: doc.title,
          signed_name: name, signature: '/s/ ' + name, email: email, context: context,
          accepted_at: new Date().toISOString(), user_agent: String(navigator.userAgent || '').slice(0, 200) };
        var sigs2 = readSigs(); sigs2.push(rec); writeSigs(sigs2);
        return json(200, { ok: true, acceptance: { document: doc.title, slug: rec.slug, version: rec.version,
          signature: rec.signature, signed_name: rec.signed_name, accepted_at: rec.accepted_at, context: context } });
      }
      return json(405, { error: 'method not allowed' });
    }, function (e) {
      // Fails closed: the page's gate refuses to continue without a documents list.
      return json(503, { error: 'Legal documents could not be loaded. ' + String(e && e.message || e) });
    });
  }

  // Signatures for the cart being created: the purchase or membership terms signed in
  // this browser in the last 24 hours. Each becomes one cart attribute, so the order
  // carries document, version, content hash, typed signature, email, time and browser.
  var CART_SLUGS = ['buyer-terms-of-purchase', 'membership-terms'];
  function gqlString(s) { return JSON.stringify(String(s)); }
  function cartAttributes() {
    var since = Date.now() - 24 * 3600 * 1000, latest = {};
    readSigs().forEach(function (s) {
      if (CART_SLUGS.indexOf(s.slug) === -1 || Date.parse(s.accepted_at) < since) return;
      if (!latest[s.slug] || s.accepted_at > latest[s.slug].accepted_at) latest[s.slug] = s;
    });
    return Object.keys(latest).map(function (k) {
      var s = latest[k];
      return { key: 'Signed: ' + s.title, value: [
        'version ' + s.version, 'hash ' + s.content_hash, s.signature, s.email,
        s.accepted_at, 'context ' + s.context, s.user_agent].join(' | ') };
    });
  }
  function withSignatures(body) {
    try {
      var o = JSON.parse(body);
      if (!o || typeof o.query !== 'string' || o.query.indexOf('cartCreate(input:{') === -1) return body;
      var attrs = cartAttributes();
      if (!attrs.length) return body;
      var lit = 'attributes:[' + attrs.map(function (a) {
        return '{key:' + gqlString(a.key) + ',value:' + gqlString(a.value) + '}';
      }).join(',') + '],';
      o.query = o.query.replace('cartCreate(input:{', 'cartCreate(input:{' + lit);
      return JSON.stringify(o);
    } catch (e) { return body; }
  }

  // ---- newsletter -------------------------------------------------------------
  // Posts Shopify's own customer (newsletter) form in the background: the customer is
  // created or updated with email marketing consent and tagged "newsletter" plus the box
  // it came from. Needs the store's contact-form hCaptcha off (Online Store >
  // Preferences, switched off 27 Sep 2026); double opt-in is switched on at the switch
  // so every signup confirms by email.
  function subscribe(email, source) {
    var fd = new URLSearchParams();
    fd.set('form_type', 'customer'); fd.set('utf8', '✓');
    fd.set('contact[email]', email);
    fd.set('contact[tags]', 'newsletter,' + String(source || 'site').replace(/[^a-z0-9-]/gi, ''));
    return realFetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd.toString() })
      .then(function (r) {
        if (/customer_posted=true/.test(r.url)) return json(200, { ok: true });
        return r.text().then(function (t) {
          var msg = '';
          try { var d = new DOMParser().parseFromString(t, 'text/html'); var e = d.querySelector('.errors, .form__message, [id*="Error"]'); msg = e ? e.textContent.trim() : ''; } catch (e2) {}
          return json(400, { error: msg || 'Something went wrong — try again' });
        });
      }, function () { return json(502, { error: 'Something went wrong — try again' }); });
  }

  // ---- accounts (Shopify customer accounts) -------------------------------------
  // Shopify signs people in with a one-time code emailed to them, on its own page, and
  // brings them back signed in. The page's Sign In / Shop With Us forms keep their look
  // without the password box; the Terms of Use step still runs before a new account
  // (the page's own gate wraps the Shop With Us submit). Name and title typed on Shop
  // With Us are kept in this browser for the greeting until the shopper sets them in
  // their Shopify profile.
  var PROFILE_KEY = 'casa_profile';
  function readProfile() { try { return JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null') || {}; } catch (e) { return {}; } }
  function goSignIn(email) {
    // /customer_authentication/login?return_to= brings the shopper back to the page
    // they were on (Shopify's plain login link always lands on the Orders page).
    window.location.href = '/customer_authentication/login?return_to=' +
      encodeURIComponent(location.pathname + location.search);
    return new Promise(function () {}); // the page is leaving
  }
  function me() {
    var c = window.CASA_CUSTOMER;
    if (!c) return null;
    var p = readProfile();
    var name = String(c.name || '').trim() || (p.email === String(c.email).toLowerCase() ? p.name : '') || '';
    return { id: c.id, email: c.email, name: name || null, role: 'customer',
      salutation: (p.email === String(c.email).toLowerCase() && p.salutation) || null };
  }
  // Mirrors the #tab-consignor submit handler in the page (casa-03.js). Null unless
  // that tab is the one on screen.
  function consignorSignup() {
    var tab = document.getElementById('tab-consignor');
    var cons = tab && tab.style.display !== 'none' && tab.querySelector('form.auth-form');
    if (!cons) return null;
    var names = cons.querySelectorAll('input[type=text]'), em = cons.querySelector('input[type=email]');
    var sels = cons.querySelectorAll('select'), boxes = cons.querySelectorAll('input[type=checkbox]');
    var ph = cons.querySelector('input[type=tel]');
    return {
      name: (((names[0] && names[0].value) || '') + ' ' + ((names[1] && names[1].value) || '')).trim(),
      email: em && em.value,
      phone: ph && ph.value,
      'Preferred payout method': sels[0] && sels[0].value,
      'How did you hear about us': sels[1] && sels[1].value,
      'Agreed to Consignor Agreement, Commission Tiers and Privacy Policy': (boxes[0] && boxes[0].checked) ? 'Yes, ' + new Date().toISOString() : 'No',
      'Consignor news and payout updates': (boxes[1] && boxes[1].checked) ? 'Opted in' : 'Not opted in',
      'Confirmed rightful owner and authentic items': (boxes[2] && boxes[2].checked) ? 'Yes' : 'No'
    };
  }
  function authRoute(p, init) {
    var b = {}; try { b = JSON.parse((init && init.body) || '{}'); } catch (e) {}
    var email = String(b.email || '').trim().toLowerCase();
    if (p === '/api/auth/me') return json(200, { user: me() });
    if (p === '/api/auth/login') return goSignIn(email);
    if (p === '/api/auth/register') {
      if (email && !EMAIL_RE.test(email)) return json(400, { error: 'Please enter a valid email address' });
      try { localStorage.setItem(PROFILE_KEY, JSON.stringify({ email: email, name: String(b.name || '').trim(), salutation: String(b.salutation || '').trim() })); } catch (e) {}
      // The Become a Consignor form files its Consignor Signup only AFTER register
      // answers, and here register leaves the page, so that never ran (found 29 Sep
      // 2026). File it first, same fields as the page's handler, then sign in.
      var signup = consignorSignup();
      if (signup) {
        return Promise.resolve(intakeRoute({ body: JSON.stringify({ type: 'consignor_signup', data: signup }) }))
          .catch(function () {}).then(function () { return goSignIn(email); });
      }
      return goSignIn(email);
    }
    if (p === '/api/auth/logout') {
      window.location.href = (window.CASA_ROUTES && window.CASA_ROUTES.logout) || '/account/logout';
      return new Promise(function () {});
    }
    if (p === '/api/auth/forgot' || p === '/api/auth/reset') return json(200, { ok: true });
    return json(404, { error: 'not found' });
  }
  // Password boxes and "Forgot password" do not apply to email-code sign-in.
  function adaptAccountForms() {
    ['#tab-signin', '#tab-register', '#tab-consignor'].forEach(function (sel) {
      document.querySelectorAll(sel + ' input[type=password]').forEach(function (i) {
        i.required = false; i.removeAttribute('minlength'); i.style.display = 'none'; i.setAttribute('aria-hidden', 'true'); i.tabIndex = -1;
      });
    });
    var fl = document.getElementById('casa-forgot-link');
    if (fl && fl.parentNode) fl.parentNode.style.display = 'none';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adaptAccountForms); else adaptAccountForms();

  // ---- wishlist (Swish) -----------------------------------------------------------
  // Same contract as api/wishlist.js: signed-in shoppers only; GET lists saved pieces
  // (sold ones stay, marked unavailable); POST/DELETE {sku} save or remove one. Stored
  // by the Swish app (theme app embeds "App Settings" and "{Code} Access").
  function waitFor(test, ms) {
    return new Promise(function (resolve, reject) {
      var t0 = Date.now();
      (function poll() { var v = test(); if (v) return resolve(v); if (Date.now() - t0 > ms) return reject(new Error('wishlist unavailable')); setTimeout(poll, 150); })();
    });
  }
  function swishReady() { return waitFor(function () { var W = window.WishlistKing; return W && W._apis && W._apis.wishlist ? W : null; }, 10000); }
  function wishlistRoute(u, init) {
    var method = String((init && init.method) || 'GET').toUpperCase();
    if (!window.CASA_CUSTOMER) return json(401, { error: 'sign in required' });
    var b = {}; try { b = JSON.parse((init && init.body) || '{}'); } catch (e) {}
    var sku = String(b.sku || '').trim().toUpperCase();
    return Promise.all([swishReady(), loadCatalog()]).then(function (res) {
      var W = res[0], c = res[1];
      var byProduct = {};
      Object.keys(c.bySku).forEach(function (k) { byProduct[c.bySku[k].productId] = Object.assign({ sku: k }, c.bySku[k]); });
      // Swish caches the list within a page; clear it so a save or remove shows at once.
      function list() {
        return Promise.resolve(W.state && W.state.clearCache ? W.state.clearCache() : null)
          .then(function () { return W._apis.wishlist.loadWishlist({ wishlistId: 'mine' }); })
          .then(function (r) { return (r && r.wishlist && r.wishlist.items) || []; });
      }
      if (method === 'GET') {
        return list().then(function (items) {
          return json(200, { items: items.map(function (i) {
            var m = byProduct[String(i.product && i.product.id)] || {};
            return { sku: m.sku || null, savedAt: i.createdAt || null, brand: m.brand || '', name: m.name || m.sku || '',
              price: m.price != null ? Number(m.price) : null, image: m.image || (i.product && i.product.featured_image) || null,
              authStatus: 'pending', available: !!m.available };
          }).filter(function (x) { return x.sku; }) });
        });
      }
      if (!sku) return json(400, { error: 'sku required' });
      var m = c.bySku[sku];
      if (!m) return json(404, { error: 'piece not found' });
      if (method === 'POST') {
        return list().then(function (items) {
          var has = items.some(function (i) { return String(i.product && i.product.id) === String(m.productId); });
          return (has ? Promise.resolve() : W.addWishlistItem({ productId: Number(m.productId), variantId: Number(m.variantId), productHandle: m.handle }))
            .then(function () { return list(); })
            .then(function (after) { return json(200, { ok: true, sku: sku, saved: true, count: after.length + (has || after.some(function (i) { return String(i.product && i.product.id) === String(m.productId); }) ? 0 : 1) }); });
        });
      }
      if (method === 'DELETE') {
        return list().then(function (items) {
          var hit = items.filter(function (i) { return String(i.product && i.product.id) === String(m.productId); });
          return Promise.all(hit.map(function (i) { return W._apis.wishlist.removeItem({ wishlistId: 'mine', wishlistItemId: i.id }); }))
            .then(function () { return json(200, { ok: true, sku: sku, saved: false, count: Math.max(0, items.length - hit.length) }); });
        });
      }
      return json(405, { error: 'method not allowed' });
    }).catch(function () { return json(500, { error: 'wishlist unavailable' }); });
  }

  // ---- routes ---------------------------------------------------------------
  var NOT_MOVED = { error: 'This part of the site is being moved to Shopify. Please email info@casaconsignment.com.' };

  // ---- membership -------------------------------------------------------------
  // Same contract as api/membership.js. Enrolment already goes straight to Shopify
  // (cartCreate with the tier's selling plan). Who is a member comes from customer tags
  // that Flow sets on subscription start and removes when access ends:
  //   casa-member:silver | casa-member:gold | casa-member:elite
  //   casa-member-yearly (annual plan), casa-member-cancelling (cancelled, paid through)
  // No renewal date: tags cannot hold one, and the panel shows none when it is absent.
  // POST (tier picked, on the way to checkout) is accepted and not stored; on Vercel it
  // also emailed info@ a lead alert, which has no Shopify equivalent here yet.
  var TIER_LABEL = { silver: 'Silver', gold: 'Gold', elite: 'Elite' };
  var TIER_PRICE = { silver: 149, gold: 299, elite: 599 };
  function membershipRoute(method) {
    var c = window.CASA_CUSTOMER;
    if (!c) return json(401, { error: 'sign in required' });
    if (method === 'POST') return json(200, { ok: true });
    var tags = (c.tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
    var tier = null;
    ['elite', 'gold', 'silver'].forEach(function (t) { if (!tier && tags.indexOf('casa-member:' + t) >= 0) tier = t; });
    if (!tier) return json(200, { membership: null, events: [] });
    var yearly = tags.indexOf('casa-member-yearly') >= 0;
    return json(200, { membership: {
      tier: tier, tierLabel: TIER_LABEL[tier],
      price: yearly ? TIER_PRICE[tier] * 12 : TIER_PRICE[tier],
      billingInterval: yearly ? 'yearly' : 'monthly',
      status: tags.indexOf('casa-member-cancelling') >= 0 ? 'cancelling' : 'active',
      since: null, lastPaidAt: null, currentPeriodEnd: null
    }, events: [] });
  }

  // ---- forms (Powerful Form Builder) ------------------------------------------
  // Same contracts as api/intake.js, api/tickets.js and api/consignment-photo.mjs.
  // Every request type has its own PFB form (IDs below); all share one field layout,
  // so one mapping serves them all. PFB sends the Casa alert (subject = the hidden
  // Subject field, the same wording Vercel used) and the approved customer reply;
  // a Shopify Flow files each submission as a tagged draft order.
  // Spec: Documents/Casa Consignment - Shopify Forms Spec, Internal (2026-09-28).md
  var PFB_SEND = 'https://app.powerfulform.com/api/front/form/';
  var FORM_ID = {
    consignment: 166216, sell_to_casa: 166223, bag_request: 166224,
    membership_interest: 166225, membership_change: 166226, consignor_signup: 166227,
    ticket: 166228
  };
  var TAG = { consignment: 'Consignment Intake', sell_to_casa: 'Sell to Casa', bag_request: 'Bag Request',
    membership_interest: 'Membership Lead', membership_change: 'Membership Change', consignor_signup: 'Consignor Signup' };
  var FILE_FIELD = { front: 'file2-1', rear: 'file2-2', side: 'file2-3', bottom: 'file2-4', inside: 'file2-5' };
  // A multiple-file input is posted as name[] (PFB's own bundle strips the [] back off).
  var EXTRA_FIELD = 'file2-6[]';
  // PFB labels a submission's fields from this map (its own form posts it too);
  // without it the admin and the Casa alert show hidden-1, name-1 and so on.
  var KEY_LABEL = JSON.stringify({ 'hidden-1': 'Subject', 'name-1': 'Name', 'email-1': 'Email', 'phone-1': 'Phone',
    'textarea-1': 'Details', 'file2-1': 'Front', 'file2-2': 'Rear', 'file2-3': 'Side', 'file2-4': 'Bottom',
    'file2-5': 'Inside', 'file2-6': 'Additional photos' });
  var MAX_PHOTO = 30 * 1024 * 1024; // PFB Premium file limit

  // Photos upload one slot at a time, before the form is sent (same as Vercel). They
  // are held in this tab and attached to the PFB submission as files; the page only
  // ever sees an object URL, which it uses as the "uploaded" marker.
  var photoStore = {};
  function photoRoute(u, init) {
    var slot = String(u.searchParams.get('slot') || '').toLowerCase();
    var body = init && init.body;
    if (!(body instanceof Blob)) return json(400, { ok: false, error: 'no image' });
    if (!/^image\//.test(body.type || 'image/jpeg')) return json(415, { ok: false, error: 'images only' });
    if (body.size > MAX_PHOTO) return json(413, { ok: false, error: 'photo too large' });
    if (!FILE_FIELD[slot] && slot !== 'extra') return json(400, { ok: false, error: 'unknown slot' });
    var url = URL.createObjectURL(body);
    photoStore[url] = body;
    return json(200, { ok: true, url: url, slot: slot });
  }

  // api/intake.js pick(): form keys are label text, so fields are found loosely.
  function pick(data, needles) {
    for (var key in data) {
      var lk = key.toLowerCase();
      for (var i = 0; i < needles.length; i++) { if (lk === needles[i] || lk.indexOf(needles[i]) >= 0) return data[key]; }
    }
    return '';
  }

  function sendForm(type, f) {
    var fd = new FormData();
    fd.append('hidden-1', f.subject || '');
    fd.append('name-1', f.name || '');
    fd.append('email-1', f.email || '');
    fd.append('phone-1', f.phone || '');
    fd.append('textarea-1', f.details || '');
    var photos = f.photos || {};
    Object.keys(FILE_FIELD).forEach(function (slot) {
      var b = photoStore[photos[slot]];
      if (b) fd.append(FILE_FIELD[slot], b, slot + '.jpg');
    });
    (photos.extra || []).forEach(function (url, i) {
      var b = photoStore[url];
      if (b) fd.append(EXTRA_FIELD, b, 'extra-' + (i + 1) + '.jpg');
    });
    var c = window.CASA_CUSTOMER;
    if (c) { fd.append('customer[id]', c.id); fd.append('customer[email]', c.email || ''); fd.append('customer[name]', c.name || ''); }
    fd.append('_keyLabel', KEY_LABEL);
    fd.append('page[title]', document.title);
    fd.append('page[href]', location.href);
    return realFetch(PFB_SEND + FORM_ID[type] + '/send', { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        var ok = res.ok && res.j && String(res.j.success) === 'true';
        if (!ok) throw new Error((res.j && (res.j.message || res.j.error)) || 'form not accepted');
        return res.j.id;
      });
  }

  function membershipChangeFields(data) {
    var c = window.CASA_CUSTOMER;
    if (!c) return { error: [401, 'Please sign in to change your membership.'] };
    var tags = (c.tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
    var cur = null;
    ['elite', 'gold', 'silver'].forEach(function (t) { if (!cur && tags.indexOf('casa-member:' + t) >= 0) cur = t; });
    if (!cur) return { error: [400, 'We could not find a paid membership on your account. Please contact us and we will help.'] };
    var to = String((data && (data.to || data.tier)) || '').trim().toLowerCase();
    if (!TIER_LABEL[to]) return { error: [400, 'Please choose Silver, Gold or Elite.'] };
    if (to === cur) return { error: [400, 'That is already your tier.'] };
    var status = tags.indexOf('casa-member-cancelling') >= 0 ? 'cancelling' : 'active';
    return { data: {
      brand: 'Membership',
      model: TIER_LABEL[cur] + ' to ' + TIER_LABEL[to],
      name: c.name || '', email: c.email || '',
      'Current tier': TIER_LABEL[cur] + ' ($' + TIER_PRICE[cur] + '/month), status ' + status,
      'Requested tier': TIER_LABEL[to] + ' ($' + TIER_PRICE[to] + '/month)',
      'How to switch': 'Shopify admin: Apps, Subscriptions, Contracts, search the member, pencil on Subscription details, replace the product with the ' + TIER_LABEL[to] + ' membership, Save. The billing date stays the same; the new price applies from the next payment. Then mark this request Complete.'
    } };
  }

  function intakeRoute(init) {
    var b = {}; try { b = JSON.parse((init && init.body) || '{}'); } catch (e) {}
    var type = b.type;
    var data = b.data && typeof b.data === 'object' ? b.data : {};
    if (!FORM_ID[type] || type === 'ticket') return json(400, { ok: false, error: 'unknown request type' });
    if (type === 'membership_change') {
      var m = membershipChangeFields(data);
      if (m.error) return json(m.error[0], { ok: false, error: m.error[1] });
      data = m.data;
    }
    var email = String(data.email || pick(data, ['email']) || '').trim();
    var name = String(data.name || pick(data, ['your name', 'name']) || '').trim();
    var phone = String(data.phone || pick(data, ['phone']) || '').trim();
    var brand = String(data.brand || pick(data, ['brand', 'designer']) || '').trim();
    var model = String(data.model || pick(data, ['model']) || '').trim();
    // Same server-side guards as api/intake.js.
    if (type === 'bag_request') {
      if (!email || !EMAIL_RE.test(email)) return json(400, { ok: false, error: 'A valid email is required so we can reply.' });
      var spec = String(data['Colour / size / hardware'] || '').trim();
      if (!model && !spec && (!brand || /not sure/i.test(brand))) return json(400, { ok: false, error: 'Please name a brand or a model so we know what to look for.' });
    }
    if (type === 'consignment') {
      if (!brand) return json(400, { ok: false, error: 'Please select a designer or brand.' });
      if (!model) return json(400, { ok: false, error: 'Please enter a model or style.' });
    }
    var title = [brand, model].filter(Boolean).join(' ') || (TAG[type] + ' submission');
    // Alert subjects, word for word from the NOTIFY map in api/intake.js.
    var subject = {
      bag_request: 'Bag request — ' + title,
      consignment: 'Consignment request — ' + title,
      sell_to_casa: 'Sell to Casa — ' + title,
      consignor_signup: 'New consignor account — ' + (name || email || 'new consignor'),
      membership_change: 'Membership change request: ' + title,
      membership_interest: 'Membership interest — ' + (name || email || 'new lead')
    }[type];
    var lines = [];
    for (var k in data) {
      if (k === 'photos' || k === 'submission_ref') continue;
      var v = data[k];
      if (v === '' || v == null || v === false) continue;
      lines.push(k + ': ' + (v === true ? 'yes' : String(v)));
    }
    return sendForm(type, { subject: subject, name: name, email: email, phone: phone,
      details: lines.join('\n'), photos: data.photos })
      .then(function (id) { return json(200, { ok: true, filed: true, id: id }); },
        function (e) { return json(502, { ok: false, error: String(e && e.message || e) }); });
  }

  function ticketRoute(init) {
    var b = {}; try { b = JSON.parse((init && init.body) || '{}'); } catch (e) {}
    var subject = String(b.subject || '').trim().slice(0, 200);
    var body = String(b.body || '').trim().slice(0, 4000);
    var email = String(b.email || '').trim().toLowerCase();
    if (subject.length < 3 || body.length < 5) return json(400, { error: 'Please add a subject and a message.' });
    if (!EMAIL_RE.test(email)) return json(400, { error: 'Please enter a valid email address so we can reply.' });
    var from = body.match(/^From: (.+)$/m);
    return sendForm('ticket', { subject: '[Casa Ticket] ' + subject, name: from ? from[1].trim() : '', email: email,
      details: 'Subject: ' + subject + '\n\n' + body, photos: { extra: Array.isArray(b.photos) ? b.photos : [] } })
      .then(function (id) { return json(200, { ok: true, ticket: { id: id, subject: subject } }); },
        function (e) { return json(502, { error: 'Could not submit ticket: ' + String(e && e.message || e) }); });
  }

  function route(u, init) {
    var method = String((init && init.method) || 'GET').toUpperCase();
    var p = u.pathname;

    if (p === '/api/legal') return legalRoute(u, init);
    if (p === '/api/subscribe' && method === 'POST') {
      var sb = {}; try { sb = JSON.parse((init && init.body) || '{}'); } catch (e) {}
      var em = String(sb.email || '').trim();
      if (!EMAIL_RE.test(em)) return json(400, { error: 'Please enter a valid email address' });
      return subscribe(em, sb.source);
    }

    if (p === '/api/products' && method === 'GET') {
      return loadCatalog().then(function (c) { return json(200, { products: c.products }); },
        function (e) { return json(502, { error: String(e && e.message || e) }); });
    }
    if (p === '/api/editorial') return json(200, { editorial: {} });
    if (p === '/api/client-signal' || p === '/api/cron-health') return json(200, { ok: true });
    if (p.indexOf('/api/auth/') === 0) return authRoute(p, init);
    if (p === '/api/wishlist') return wishlistRoute(u, init);
    if (p === '/api/orders' && method === 'GET') {
      var c = window.CASA_CUSTOMER;
      if (!c) return json(401, { error: 'sign in required' });
      return json(200, { orders: c.orders || [] });
    }
    if (p === '/api/membership') return membershipRoute(method);
    if (p === '/api/consignment-photo' && method === 'POST') return photoRoute(u, init);
    if (p === '/api/intake' && method === 'POST') return intakeRoute(init);
    if (p === '/api/tickets' && method === 'POST') return ticketRoute(init);

    return json(503, NOT_MOVED);
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var u = new URL(url, location.href);
      if (u.origin === location.origin && u.pathname.indexOf('/api/') === 0 &&
          // Shopify's own Storefront endpoint on this domain is real, leave it alone.
          !/^\/api\/\d{4}-\d{2}\//.test(u.pathname)) {
        return route(u, init);
      }
      // Checkout carts: attach the signatures (see withSignatures).
      if (u.host === SF_DOMAIN && /\/api\/\d{4}-\d{2}\/graphql\.json$/.test(u.pathname) &&
          init && typeof init.body === 'string') {
        init = Object.assign({}, init, { body: withSignatures(init.body) });
      }
    } catch (e) {}
    return realFetch(input, init);
  };

  // Failure beacons went to /api/client-signal on Vercel. Drop them here.
  if (navigator.sendBeacon) {
    var realBeacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url, data) {
      try { if (new URL(url, location.href).pathname.indexOf('/api/') === 0) return true; } catch (e) {}
      return realBeacon(url, data);
    };
  }

  // Shopper steps (Quick View, Add to Bag, Checkout Started, Checkout Handoff) went
  // to Vercel Analytics. They now go to Shopify as custom events, which pixels and
  // apps can read. Product ids and counts only, as before.
  function wrapTrack() {
    var orig = window.casaTrack;
    window.casaTrack = function (name, data) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('casa_' + String(name).toLowerCase().replace(/[^a-z0-9]+/g, '_'), data || {}); } catch (e) {}
      try { if (orig) orig(name, data); } catch (e) {}
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wrapTrack); else wrapTrack();
})();
